app.controller('patientViewController', ['$rootScope', '$scope', '$state', '$stateParams', 'objectHelper', 'baseModel',
    'applicationModel', 'patientModel', 'visitModel', 'ewusModel', 'userModel', '$timeout', 'config',
    function ($rootScope, $scope, $state, $stateParams, objectHelper, baseModel, applicationModel, patientModel, visitModel,
              ewusModel, userModel, $timeout, config) {


        // fixme - this is shitty - but had no time for better solution
        function getSelectedTabIndex () {
            switch ($state.current.name) {
                case Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD:
                case Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_CORRECT:
                case Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_VIEW:
                    return 0;
                case Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.GENERAL:
                case Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.ALLERGIES:
                case Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.TAKEN_DRUGS:
                case Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.DIAGNOSES:
                case Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.HOSPITAL_AND_SANATORIUMS:
                case Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.LABORATORY_TEST_RESULTS:
                case Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.VACCINATION_AND_SERUMS:
                case Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.GENETIC_DISORDERS:
                    if($scope.hasRightToVisitCardModule() && $scope.visitId) {
                        return 2;
                    } else {
                        return 1;
                    }
                case Constant.STATE.APP.PATIENT.VIEW.VISIT_LIST:
                case Constant.STATE.APP.PATIENT.VIEW.VISIT_CREATE:
                    if($scope.hasRightToVisitCardModule() && $scope.visitId) {
                        if($scope.hasRightToStateOfHealth()) {
                            return 3;
                        } else {
                            return 2;
                        }
                    } else {
                        if($scope.hasRightToStateOfHealth()) {
                            return 2;
                        } else {
                            return 1;
                        }
                    }

                case Constant.STATE.APP.PATIENT.VIEW.EXPORT_LOG:
                    if($scope.visitId) {
                        return 4;
                    } else {
                        return 3;
                    }

                case Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA:
                    if($scope.visitId) {
                        return 1;
                    } else {
                        return 0;
                    }
            }



        }

        function setData() {
            $scope.patient = null;

            $scope.patientId = $stateParams.patientId;
            $scope.visitId = $stateParams.visitId;

            $scope.viewStyle = {'align-items': 'flex-start'};

            $scope.$parent.visitCardMode = 'view';

            $scope.vm = {
                selectedTabIndex: 0,
                viewTabBar: true
            };
        }

        function setPermissions() {
        }

        function setListeners() {
            $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                $scope.vm.selectedTabIndex = getSelectedTabIndex();
            });

            $scope.$on(Event.PATIENT.GET_BY_ID.SUCCESS, function (event, patient) {
                $scope.patient = patient;

                if (config.DEMO) {
                    $scope.vm.viewTabBar = true;
                } else {
                    $scope.vm.viewTabBar = !$scope.patient.toBeVerified;
                }

                if($scope.visitId) {
                    visitModel.getById($stateParams.visitId);
                }
            });

            $scope.$on(Event.VISIT.GET_BY_ID.SUCCESS, function(event, visit) {
                $scope.visit = visit;
            });

            $scope.$on(Event.EWUS.UPDATE_REFUNDATION_STATUS_FOR_VISIT.SUCCESS, function(event, visit) {
                $scope.visit = visit;
            });
        }

        function setActions() {
            $scope.goToPatientList = function () {
                $state.go(Constant.STATE.APP.PATIENT.LIST);
            };

            $scope.goToStateOfHealth = function () {
                if($state.current.name.indexOf(Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.STATE_OF_HEALTH) == -1) {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.STATE_OF_HEALTH.GENERAL, {patientId: $scope.patientId, visitId: $scope.visitId});
                }
            };

            $scope.setStretchView = function () {
                $scope.viewStyle = {'align-items': 'stretch'};
            };

            $scope.resetStretchView = function () {
                $scope.viewStyle = {'align-items': 'flex-start'};
            };

            $scope.checkEWUSstatus = function() {
                var today = new Date();
                if ($scope.visit.date.toDateString() == today.toDateString()) {
                    ewusModel.updateRefundStatusForVisit($stateParams.visitId);
                }
            };

            $scope.hasRightToVisitCardModule = function () {
                return userModel.userHasRight(Constant.RIGHT.VISIT_CARD_MODULE_ACCESS);
            };

            $scope.hasRightToStateOfHealth = function () {
                return userModel.userHasRight(Constant.RIGHT.PATIENTS_STATE_OF_HEALTH_READ);
            };

            $scope.checkProperTab = function(viewMode) {
                return $scope.hasRightToVisitCardModule() && $scope.visitId && ($scope.$parent.visitCardMode === viewMode);
            }
        }

        function configureInterface() {

        }

        function initialize() {
            patientModel.getById($stateParams.patientId);

            $timeout(function() {
                $scope.vm.selectedTabIndex = getSelectedTabIndex();
            })
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
